<template>
    <tr class="no_edit">
      <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="entity.id"
               :value="entity.id"
               @click.stop
               @change="onChange"
               :checked="isChecked"
        />
        <label
            :for="entity.id"
            @click.stop
            v-translate>Vybrat
        </label>
      </td>
        <td :data-th="'MAC Adresa' | translate" class="first_data">{{ entity.mac_address }}</td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"

	export default {
		name: "MacAddressRow",
    mixins: [rowActions],
		props: {
			entity: Object
		},
		methods: {
			emitDeleteMacAddress() {
				this.$emit('delete-mac-address', this.entity)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/registeredMacAddress/RegisteredMacAddressBatchDetailMacAddressRow.vue